import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getOrderSheetById } from 'apis/CommerceGraphql/chatOrder';
import { setOrderSheet } from 'store/ducks/chatOrderStore';
import { StoreState } from 'store/ducks';

export const useOrderSheet = (storeOrderId: string) => {
  const dispatch = useDispatch();
  const orderSheet = useSelector((state: StoreState) => state.chatOrderStore.orderSheets[storeOrderId]);

  useEffect(() => {
    if (orderSheet) return;

    const fetchOrderSheet = async () => {
      const result = await getOrderSheetById(storeOrderId);
      if (result) {
        dispatch(setOrderSheet({ storeOrderId, orderSheet: result }));
      }
    };

    fetchOrderSheet();
  }, [storeOrderId, orderSheet, dispatch]);

  return {
    orderSheet,
    invoice: orderSheet?.deliveryTracking?.invoice ?? null,
  };
};
